export const fleetExpensesTutorialSteps = [
  {
    target: '#fleet-expenses-header',
    title: 'Centro de gastos de flota',
    content: 'Desde esta cabecera ubicás la empresa, abrís el tutorial y entrás al módulo que concentra combustible, service, multas y otros gastos por unidad.',
    narration: 'Desde esta cabecera ubicás la empresa, abrís el tutorial y entrás al módulo que concentra combustible, service, multas y otros gastos por unidad.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-form',
    title: 'Carga operativa',
    content: 'Acá registrás el gasto nuevo, asociándolo a una categoría y a una unidad para que después impacte ordenado en el historial y en los reportes.',
    narration: 'Acá registrás el gasto nuevo, asociándolo a una categoría y a una unidad para que después impacte ordenado en el historial y en los reportes.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-categories',
    title: 'Categorías de gasto',
    content: 'Este bloque te deja ordenar el lenguaje del módulo: combustible, peaje, reparación, multa u otras categorías propias de la empresa.',
    narration: 'Este bloque te deja ordenar el lenguaje del módulo: combustible, peaje, reparación, multa u otras categorías propias de la empresa.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-history',
    title: 'Historial por unidad',
    content: 'Acá revisás qué se cargó, cuándo, por cuánto y en qué transporte, con filtros para leer rápido la película de la flota.',
    narration: 'Acá revisás qué se cargó, cuándo, por cuánto y en qué transporte, con filtros para leer rápido la película de la flota.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#fleet-expenses-chart',
    title: 'Lectura visual',
    content: 'El gráfico final te resume en qué rubros se está yendo más dinero para que detectes desvíos o hábitos de gasto.',
    narration: 'El gráfico final te resume en qué rubros se está yendo más dinero para que detectes desvíos o hábitos de gasto.',
    placement: 'top',
    disableBeacon: true,
  },
];

export default fleetExpensesTutorialSteps;
